import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import InvoiceBatch from '../../entities/invoiceBatch';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteInvoiceBatch(): boolean {
return true;
}
export function collectInvoiceBatchDeleteImpact(invoiceBatch: InvoiceBatch, context: DeleteImpactContext): void {
const key = 'invoiceBatch:' + invoiceBatch.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
}
export function deleteImpactInvoiceBatch(invoiceBatch: InvoiceBatch): DeleteImpact {
const context = deleteImpactContext();
collectInvoiceBatchDeleteImpact(invoiceBatch, context);
return deleteImpactCounts(context);
}
export function deleteInvoiceBatch(invoiceBatch: InvoiceBatch, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteInvoiceBatch()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectInvoiceBatchDeleteImpact(invoiceBatch, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || invoiceBatch.id};
}
const key = 'invoiceBatch:' + invoiceBatch.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));

const deleted = invoiceBatch.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.InvoiceBatchActions.removeInvoiceBatchQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}
